import { createAsyncThunk } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { IHistory } from 'features/EngineeringNetStatus/EngineeringInfo/GuaranteeLetter/types';

export const getHistoryGaranteeLetter = createAsyncThunk(
  'EN_guaranteeLetter/getHistoryGaranteeLetter',
  async (id: number, thinkApi) => {
    try {
      const { data } = await get<IHistory[]>(
        `/api/standards/engineering_networks/${id}/guarantee-letter/history/`,
      );
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
